import React, { useEffect, useRef, useState } from 'react'
import useModal from '../../../utils/hooks/useModal'
import { useHistory } from "react-router-dom";
import { Translate } from '../../../language'
import ButtonIcon from '../../../utils/components/ButtonIcon/ButtonIcon'
import ModalNewPost from '../../ModalNewPost'
import { TextIcon, VideoIcon, PictureIcon, GifIcon, AudioIcon, AdminChatIcon } from '../../../assets/icons'
import zones from '../../../assets/img/zones.png'
import rooms from '../../../assets/img/rooms.png'
import './NewPost.css'
import { useDispatch } from 'react-redux';
import { checkPoints } from '../../../actions/fileUploadActions';
import localStorage from '../../../utils/hooks/useLocalStorage';

const NewPost = ({ type, zone, isPostCampaign, _idEc, show = true }) => {
    const [refNewPost, isShowNewPost, setIsShowNewPost] = useModal(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [profileType, setProfileType] = useState(localStorage().getItem("typeProfile"));
    useEffect(() => {
        setProfileType(localStorage().getItem("typeProfile"));
    }, [localStorage().getItem("typeProfile")]);
    return (
        <div className={`container-new-post ${type}`} ref={refNewPost}>
            {
                (show && (zone || localStorage().getItem("typeProfile")!="warehouse")) && <div className="icon-plus-new-post" onClick={() => {

                    if (_idEc) {
                        dispatch(checkPoints(_idEc, () => setIsShowNewPost(true)))
                    } else {
                        setIsShowNewPost(true)
                    }

                }}>
                    +
                </div>
            }
            <ModalNewPost
                zone={zone}
                nameUser={localStorage().getItem("nameUser")}
                urlUser={localStorage().getItem("picturProfile")}
                view='Home'
                history={history}
                displayModal={isShowNewPost}
                closeModal={() => setIsShowNewPost(false)}
                content={"new post"}
                isPostCampaign={isPostCampaign}
                _idEc={_idEc}
            />
            <div className='zonesRooms-btn-container'>
                <div className="icon-plus-new-post" onClick={() => {
                    history.push("/Rooms/")
                }}>
                    <img height={27} src={rooms} />
                </div>

                <div className="icon-plus-new-post" onClick={() => {
                    history.push("/Zones/")
                }}>
                    <img height={27} src={zones} />
                </div>


                {
                    (localStorage().getItem("typeProfile") === "franchise"  || localStorage().getItem("typeProfile") === "warehouse" ) && <div className="icon-plus-new-post" onClick={() => {
                        history.push("/Messages/Admin/")
                    }}>
                        <AdminChatIcon height={27} />
                    </div>
                }
            </div>
        </div>
    )
}

export default NewPost
